import React from "react";
import "./App.css";
import AccountAction from "./containers/AccountAction/AccountAction";
import HomePage from './components/HomePage/HomePage';
import {
  Route,
  Router,
  Switch,
} from "react-router-dom";




function App() {
  
  return(
    <div className="App">
          <AccountAction/>      
    </div>
  );

}

export default App;
